import { buildDialog } from "./utils/core/dialogBuilder.js";
import { applySheets } from "../../../app/utils/styleCache.js";

export class AppDialog extends HTMLElement {
    constructor() {
        super();
        this.attachShadow({ mode: "open" });
        this.contentEl  = null;
        this.backdropEl = null;
        this.titleEl    = null;
        this.backBtn    = null;
    }

    connectedCallback() {
        const root = this.shadowRoot;

        root.innerHTML = `
            <style>
                :host(:not([loaded])) { display: none; }
                .headerToolBack.hidden { display: none; }
            </style>
            <div class="dialog" id="dialog">
                <header>
                    <div class="headerToolBack headerTool hidden" id="dialogBack">
                        <i class="fa-solid fa-arrow-left fa-xl"></i>
                    </div>
                    <p class="title" id="dialogTitle"></p>
                    <div class="headerToolClose headerTool" id="dialogClose">
                        <i class="fa-solid fa-x fa-xl"></i>
                    </div>
                </header>
                <div id="dialogContent"></div>
            </div>
            <div class="backgroundBlur" id="dialogBackdrop"></div>
        `;

        this.contentEl  = root.querySelector("#dialogContent");
        this.backdropEl = root.querySelector("#dialogBackdrop");
        this.titleEl    = root.querySelector("#dialogTitle");
        this.backBtn    = root.querySelector("#dialogBack");

        root.querySelector("#dialogClose").addEventListener("click", () => this.close());
        this.backBtn.addEventListener("click", () => this.dispatchEvent(new CustomEvent("back", { bubbles: true })));
        this.contentEl.addEventListener("change", (e) => {
            if (e.target.tagName === "SELECT") e.target.blur();
        });

        applySheets(root, [
            "https://cdn.jsdelivr.net/npm/tom-select@2.5.2/dist/css/tom-select.css",
            "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.0.0/css/all.min.css",
            "components/features/app-dialog/app-dialog.css",
        ]).then(() => {
            if (this.hasAttribute("loaded")) return;
            this.setAttribute("loaded", "");
            this.dispatchEvent(new CustomEvent("loaded"));
        });
    }

    async open(config = {}) {
        if (!document.contains(this)) document.body.appendChild(this);

        if (!this.hasAttribute("loaded"))
            await new Promise(resolve => this.addEventListener("loaded", resolve, { once: true }));

        const content = buildDialog(config);
        if (!content) return;

        this.titleEl.textContent = config.header?.title ?? "";
        this.backBtn.classList.toggle("hidden", !config.header?.back);

        this.contentEl.innerHTML = "";
        this.contentEl.appendChild(content);

        requestAnimationFrame(() => {
            this.shadowRoot.querySelector("#dialog").classList.add("open");
            this.backdropEl.classList.add("open");
        });
    }

    close() {
        this.dispatchEvent(new CustomEvent("close", { bubbles: true }));
        this.shadowRoot?.querySelector("#dialog")?.classList.remove("open");
        this.backdropEl?.classList.remove("open");
    }
}

customElements.define("app-dialog", AppDialog);